import { Box } from "@mui/material";
import { startFetchSections } from "actions/sections";
import Spinner from "components/common/Spinner";

import {
  initialState,
  sectionReducer,
} from "context/courseSections/sectionsReducer";
import { types } from "context/types/types";
import React, { useEffect, useReducer, useState } from "react";
import ModalFormSection from "./ModalFormSection";
import Sections from "./Sections";

const Lessons = ({ courseId }) => {
  //reducer para SECTIONS
  const [sections, dispatch] = useReducer(sectionReducer, initialState);

  //Fetch Sections
  useEffect(() => {
    const fetchSections = async () => {
      dispatch({ type: types.sectionStartFetch, payload: {} });
      const body = await startFetchSections(courseId);
      if (body.statusCode) {
        dispatch({ type: types.sectionFetchError, payload: body.message });
      } else {
        dispatch({
          type: types.sectionFetch,
          payload: body,
        });
      }
    };
    fetchSections();
  }, [courseId]);

  if (sections.Loading) return <Spinner />;

  return (
    //Container de toda la seccion
    <Box
      sx={{
        display: "flex !important",
        flexDirection: "column !important",
        justifyContent: "flex-start !important",
        alignItems: "center !important",
        padding: "24px !important",
        backgroundColor: "white !important",
        minHeight: "calc(100vh - 140px) !important",
        position: "relative !important",
        zIndex: "1 !important",
      }}
    >
      {/* Container del titulo */}
      <Box
        sx={{
          textAlign: "center !important",
          fontSize: "1.5rem !important",
          fontWeight: "600 !important",
          color: "#333 !important",
          marginBottom: "24px !important",
          padding: "16px 24px !important",
          backgroundColor: "rgba(88, 102, 173, 0.05) !important",
          borderRadius: "12px !important",
          border: "1px solid rgba(88, 102, 173, 0.1) !important",
        }}
      >
        <div style={{ fontSize: "24px", marginBottom: "8px" }}>📚</div>
        <span style={{ display: "block", fontSize: "18px", fontWeight: "600", marginBottom: "4px" }}>
          Gestión de Clases
        </span>
        <span style={{ fontSize: "14px", color: "#666", fontWeight: "400" }}>
          Para agregar una sección presiona el botón de abajo
        </span>
      </Box>

      {/* contenedor para el boton de agregar seccion */}
      <Box
        sx={{
          display: "flex !important",
          justifyContent: "center !important",
          marginBottom: "24px !important",
        }}
      >
        <ModalFormSection dispatch={dispatch} courseId={courseId} />
      </Box>

      {/* Contenedor de todas las secciones (acordeones) */}
      <Box
        sx={{
          width: "100% !important",
          maxWidth: "1000px !important",
          height: "500px !important",
          overflow: "auto !important",
          padding: "16px !important",
          backgroundColor: "#f8f9fa !important",
          borderRadius: "12px !important",
          border: "1px solid rgba(0,0,0,0.08) !important",
          boxShadow: "inset 0 2px 8px rgba(0,0,0,0.05) !important",
          position: "relative !important",
          zIndex: "1 !important",
          // Custom scrollbar
          "&::-webkit-scrollbar": {
            width: "8px !important",
          },
          "&::-webkit-scrollbar-track": {
            background: "rgba(0,0,0,0.05) !important",
            borderRadius: "4px !important",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "linear-gradient(135deg, #5866ad 0%, #37b0cf 100%) !important",
            borderRadius: "4px !important",
            "&:hover": {
              background: "linear-gradient(135deg, #4a5a9d 0%, #2e9bb5 100%) !important",
            }
          },
        }}
      >
        {sections.sections.length > 0 ? (
          sections.sections.map((section, i) => {
            return (
              <Sections
                key={section.id}
                i={i + 1}
                text={section.name}
                sectionId={section.id}
                dispatchSection={dispatch}
              />
            );
          })
        ) : (
          <div style={{
            textAlign: "center",
            padding: "60px 20px",
            color: "#666",
          }}>
            <div style={{ fontSize: "48px", marginBottom: "16px" }}>📝</div>
            <h3 style={{ margin: "0 0 8px 0", color: "#333" }}>
              No hay secciones creadas
            </h3>
            <p style={{ margin: "0", fontSize: "14px" }}>
              Crea tu primera sección para comenzar a agregar clases
            </p>
          </div>
        )}
      </Box>
    </Box>
  );
};

export default Lessons;
